import { msgTip } from '@/utils/urlUtils'
import CountBtn from '@/components/enroll/CountBtn.vue'
export default {
  data() {
    return {
      code_error: '',
      tel_error: '',
      password_error: '',
      //手机号
      tel: '',
      //验证码
      code: '',
      //密码
      psw: '',
      //明文
      show: false
    }
  },
  components: { CountBtn },
  props: {
    clean: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    clearEnroll() {
      this.tel = ''
      this.code = ''
      this.psw = ''
      this.checked = false
      this.code_error = ''
      this.password_error = ''
      this.tel_error = ''
      this.show = false
    },
    clearLogin() {
      this.tel = ''
      this.code = ''
      this.psw = ''
      this.remember_me = false
      this.code_error = ''
      this.password_error = ''
      this.tel_error = ''
      this.active_key = 1
      this.show = false
    },
    resultHandler(msg) {
      if (msg) {
        this.tel_error = msg
      }
    },
    showError(d) {
      // msgTip({
      //   type: 'error',
      //   msg: d.error || d.password_error || d.tel_error || d.code_error || 'error'
      // })
      this.password_error = d.password_error || ''
      this.tel_error = d.tel_error || ''
      this.code_error = d.code_error
    },
    removeFocus(e) {
      let id = e.target.id
      let targetParent = e.target.parentElement
      if (targetParent) {
        let classes = targetParent.classList
        classes.remove('nor-focus')
        if (id == 'tell1' || id == 'tell2') {
          if (!/^1\d{10}$/.test(this.tel)) {
            this.tel_error = '请输入11位手机号码'
          } else {
            this.tel_error = ''
          }
        } else if (id == 'psw') {
          if (!/^[0-9a-zA-Z]{6,20}$/.test(this.psw)) {
            if (this.psw) {
              this.password_error = '请输入正确的密码'
            }
          } else {
            this.password_error = ''
          }
        }
      }
    },
    changeEye() {
      this.show = !this.show
    },
    getFocus(e) {
      let targetParent = e.target.parentElement
      if (targetParent) {
        targetParent.classList.add('nor-focus')
      }
    }
  }
}
